
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Paragraph } from '@ecl/website-components';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Paragraph size="lead" mdxType="Paragraph">
  Border utilities let you add and edit borders around any element. It allows
  you to change border direction, width and colour.
    </Paragraph>
    <h2>{`Border direction`}</h2>
    <p>{`By using classes `}<inlineCode parentName="p">{`ecl-u-border-*`}</inlineCode>{` you can draw a border on an item.
Available directions are:`}</p>
    <ul>
      <li parentName="ul">{`all`}</li>
      <li parentName="ul">{`top`}</li>
      <li parentName="ul">{`right`}</li>
      <li parentName="ul">{`bottom`}</li>
      <li parentName="ul">{`left`}</li>
    </ul>
    <h2>{`Border width`}</h2>
    <p>{`By using classes `}<inlineCode parentName="p">{`ecl-u-border-width-*`}</inlineCode>{` you can change the width of a border.
Available width are (in px):`}</p>
    <ul>
      <li parentName="ul">{`1`}</li>
      <li parentName="ul">{`2`}</li>
      <li parentName="ul">{`4`}</li>
      <li parentName="ul">{`8`}</li>
      <li parentName="ul">{`0`}</li>
    </ul>
    <h2>{`Border colour`}</h2>
    <p>{`By using classes `}<inlineCode parentName="p">{`ecl-u-border-color-*`}</inlineCode>{` you can set the colour of the border.
Available colours are:`}</p>
    <ul>
      <li parentName="ul">{`primary colours (blue, yellow, grey)`}</li>
      <li parentName="ul">{`black and white`}</li>
      <li parentName="ul">{`the `}<Link to="/ec/guidelines/colours/" mdxType="Link">{`grey palette`}</Link></li>
      <li parentName="ul">{`the `}<Link to="/ec/guidelines/colours/" mdxType="Link">{`blue palette`}</Link></li>
      <li parentName="ul">{`the `}<Link to="/ec/guidelines/colours/" mdxType="Link">{`yellow palette`}</Link></li>
      <li parentName="ul">{`the `}<Link to="/ec/guidelines/colours/" mdxType="Link">{`notification palette`}</Link></li>
    </ul>
    <h2>{`Border colour`}</h2>
    <p>{`By using classes `}<inlineCode parentName="p">{`ecl-u-border-style-*`}</inlineCode>{` you can change the style of the border.
Available styles are:`}</p>
    <ul>
      <li parentName="ul">{`solid`}</li>
      <li parentName="ul">{`dashed`}</li>
      <li parentName="ul">{`dotted`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;